import $ from 'jquery';
import LP from '../0-lp';

//=============== //
//QUESTION TABS   //
//=============== //
LP.questionTab = {};

LP.questionTab.codes = {
    initEvents: function (root) {
        if (!root) root = $('body');
        $('input#lp-auto-codes', root).change(LP.dlgQuestion.checkAutoCodes);
        LP.dlgQuestion.checkAutoCodes();
    }
};
LP.questionTab.visibility = {

    onLoad: function (root) {
        LP.questionTab.visibility.initEvents(root);
    },

    initEvents: function () {
        LP.filters.init({root: $('#fs-question-visibility')});
    }
};

LP.questionTab.jumps = {
    dispatching: false,

    onLoad: function () {
        LP.questionTab.jumps.initEvents();
        LP.questionTab.jumps.checkJumps();
    },

    initEvents: function () {
        LP.filters.init({root: $('#fs-question-jumps')});
    }
};

LP.questionTab.itemVisibility = {
    dispatching: false,

    prepare: function (selector, params) {
        $(selector).click(function () {
            if (!$(this).is('[disabled]'))
                LP.Dialog.open($.extend(params, {
                    name: "itemVisiblitity",
                    ajax: $(this).attr('url'),
                    request: $(this).attr('url_params'),
                    title: this.title,
                    width: 690,
                    height: 490,
                    sizeable: true,
                    onLoad: LP.questionTab.itemVisibility.onLoad,
                    beforeSubmit: LP.questionTab.itemVisibility.beforeSubmit,
                    afterSubmit: LP.questionTab.itemVisibility.onSubmit,
                    onClose: LP.questionTab.itemVisibility.onClose
                }));
            return false;
        });
    },

    onLoad: function () {
        LP.filters.init({root: $('#fs-item-visibility')});
    },

    beforeSubmit: function () {
        LP.filters.removeEmptyTerms($('#fs-item-visibility'));
        return true;
    },

    onClose: function () {
        return false;
    },
};

